import Section from 'components/common/Section';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Environment from 'assets/img/illustrations/undraw_environment_iaus.svg';

const ErrorSelectCluster = () => {
  return (
    <Section className="py-0">
      <Row className="flex-center min-vh-75 pt-0 pt-lg-7">
        <Col sm={11} md={9} lg={7} xl={6} className="col-xxl-5 p-0">
          <div className="text-center">
            <div className="w-100 text-center">
              <img
                className="w-50"
                src={Environment}
                alt="environment Illustration"
              />
            </div>
            <p className="lead mt-4 text-800 font-sans-serif fw-semi-bold">
              Please select a cluster from above dropdown.
            </p>
          </div>
        </Col>
      </Row>
    </Section>
  );
};

export default ErrorSelectCluster;
